import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HintTemplateConstant } from './hint-dynamic.constants';

@Component({
  selector: 'gtd-hint-dynamic-component',
  templateUrl: './hint-dynamic.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintDynamicComponent {
  @Input() hintTemplate: string;
  public HintTemplateConstant = HintTemplateConstant;
}
